import "./App.css";
import Navbar from "./frontend/Home/Navbar/Navbar";
import Router from "./frontend/Routes/Router";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Router />
    </div>
  );
}

export default App;
